import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Delete from "@material-ui/icons/Delete";
import { Block } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    height: 40,
    margin: "0 auto 3px",
    padding: "0px 10px",
    fontSize: "14px",
    background: "white",
  },
}));
export default function CompareInput({
  handleChange,
  handleRemove,
  listLength,
  index,
  value,
}) {
  const classes = useStyles();
  const handleLocalChange = (e) => {
    handleChange(e, index);
  };
  return (
    <>
      <OutlinedInput
        id="outlined-adornment-password"
        type="text"
        name="text"
        value={value}
        placeholder="Type here to compare upto 7 items"
        onChange={handleLocalChange}
        className={`${classes.input}`}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" edge="end">
              {listLength - 1 !== index && (
                <Delete onClick={() => handleRemove(index)} />
              )}
            </IconButton>
          </InputAdornment>
        }
        labelWidth={0}
      />
    </>
  );
}
